module.exports = new __parcel__URL__("is-found-tag.5f0e54d1.html").toString();